(function () {
    var ROOT_SEL = '[id^="js-flowbox-flow-"]';
    var ITEM_IMG_CONTAINER = '.bzfy-o-image-container';
    var OVERLAY_SEL = '.hover-div';
    var PAGE_CLIENTS = document.getElementById('flowboxphotosclients');
    var FALLBACK_HANDLE = '@bobochicparis';

    function getFlowLocale() {
        var root = document.querySelector(ROOT_SEL);
        if (!root) return '';
        return (root.getAttribute('data-flowbox-locale') || root.getAttribute('lang') || '').toLowerCase();
    }

    function isNl() {
        var l = getFlowLocale();
        return l.indexOf('nl') === 0 || l.indexOf('nl-') === 0;
    }

    function t(key) {
        var dict = {
            moreInfo: {
                fr: "Plus d'informations",
                nl: "Meer informatie"
            }
        };
        return isNl() ? dict[key].nl : dict[key].fr;
    }

    function whenExists(selector, cb) {
        var el = document.querySelector(selector);
        if (el) return cb(el);
        var mo = new MutationObserver(function () {
            var found = document.querySelector(selector);
            if (found) { mo.disconnect(); cb(found); }
        });
        mo.observe(document.documentElement, { childList: true, subtree: true });
    }

    function createOverlayButtonOnly() {
        var wrap = document.createElement('div');
        wrap.className = 'hover-div';
        wrap.setAttribute('aria-hidden', 'true');
        wrap.style.pointerEvents = 'none';

        var inner = document.createElement('div');
        inner.className = 'text_bottom';

        var btn = document.createElement('span');
        btn.className = 'plus_dinfos';
        btn.textContent = t('moreInfo');
        btn.style.pointerEvents = 'none';

        inner.appendChild(btn);
        wrap.appendChild(inner);
        return wrap;
    }

    function getHandleFromCard(card) {
        var p = card.querySelector('.bzfy-c-tilegrid-post__minimalistic-overlay-content p');
        var h = (p ? p.textContent : '').trim();

        if (!h) {
            var img = card.querySelector('img');
            var alt = (img && img.alt) ? img.alt : '';
            var m = alt.match(/par\s+(@?[A-Za-z0-9._-]+)/i);
            if (m && m[1]) h = m[1];
        }

        if (!h || h.indexOf('@') === -1) h = FALLBACK_HANDLE;
        if (h[0] !== '@') h = '@' + h;
        return h;
    }

    function createOverlayWithHandle(handleText) {
        var wrap = document.createElement('div');
        wrap.className = 'hover-div';
        wrap.setAttribute('aria-hidden', 'true');
        wrap.style.pointerEvents = 'none';

        var inner = document.createElement('div');
        inner.className = 'text_bottom';

        var title = document.createElement('span');
        title.className = 'titre';
        title.textContent = handleText.toUpperCase();

        var desc = document.createElement('div');
        desc.className = 'description';
        desc.innerHTML = '&nbsp;';

        var btn = document.createElement('span');
        btn.className = 'plus_dinfos';
        btn.textContent = t('moreInfo');

        inner.appendChild(title);
        inner.appendChild(desc);
        inner.appendChild(btn);
        wrap.appendChild(inner);
        return wrap;
    }

    function ensureOverlayFor(container, overlayFactory) {
        if (!container) return;
        var existing = container.querySelector(OVERLAY_SEL);
        if (existing) {
            if (!existing.querySelector('.titre') && overlayFactory !== createOverlayButtonOnly) {
                existing.remove();
            } else {
                return;
            }
        }
        if (getComputedStyle(container).position === 'static') {
            container.style.position = 'relative';
        }
        container.appendChild(overlayFactory());
    }

    function scanProduit(root) {
        (root || document).querySelectorAll(ITEM_IMG_CONTAINER).forEach(function (node) {
            ensureOverlayFor(node, createOverlayButtonOnly);
        });
    }

    function scanClients(root) {
        var scope = (root || document);
        scope.querySelectorAll('#flowboxphotosclients #js-flowbox-flow .bzfy-c-tilegrid-post-container .bzfy-c-tilegrid-post-container__inner')
            .forEach(function (card) {
                var imgWrap = card.querySelector(ITEM_IMG_CONTAINER) || card;
                var handle = getHandleFromCard(card);
                ensureOverlayFor(imgWrap, function () { return createOverlayWithHandle(handle); });
            });
    }

    whenExists(ROOT_SEL, function (root) {
        if (PAGE_CLIENTS) {
            scanClients(root);
        } else {
            scanProduit(root);
        }

        var observer = new MutationObserver(function (mList) {
            for (var i = 0; i < mList.length; i++) {
                var m = mList[i];
                if (m.type === 'childList' && m.addedNodes && m.addedNodes.length) {
                    if (PAGE_CLIENTS) {
                        scanClients(root);
                    } else {
                        scanProduit(root);
                    }
                    break;
                }
            }
        });
        observer.observe(root, { childList: true, subtree: true });

        var rescanner = setInterval(function () {
            if (PAGE_CLIENTS) { scanClients(root); } else { scanProduit(root); }
        }, 2000);

        document.addEventListener('shopify:section:unload', function (e) {
            if (e && e.target && e.target.contains(root)) {
                observer.disconnect();
                clearInterval(rescanner);
            }
        });
    });
})();

(function () {
    function getFlowLocale() {
        var el = document.querySelector('[id^="js-flowbox-flow-"]');
        if (!el) return '';
        return (el.getAttribute('data-flowbox-locale') || el.getAttribute('lang') || '').toLowerCase();
    }

    function isNl() {
        var l = getFlowLocale();
        return l.indexOf('nl') === 0 || l.indexOf('nl-') === 0;
    }

    function moreInfoLabel() {
        return isNl() ? 'Meer informatie' : "Plus d'informations";
    }

    function debounce(fn, wait) {
        var t;
        return function () {
            var ctx = this, args = arguments;
            clearTimeout(t);
            t = setTimeout(function () { fn.apply(ctx, args); }, wait || 150);
        };
    }

    function addHoverDivListing(root) {
        const observer = new MutationObserver(function () {
            const cards = root.querySelectorAll(
                '.bzfy-c-tilegrid-post-container .bzfy-c-tilegrid-post-container__inner, .bzfy-o-image-container'
            );
            if (!cards.length) return;

            cards.forEach(function (card) {
                card.classList.add('bobo-hoverable');

                if (card.querySelector('.hover-div')) return;

                let title = '@bobochicparis';
                const t = card.querySelector('.bzfy-c-tilegrid-post__minimalistic-overlay-content p');
                if (t && t.textContent && t.textContent.trim().indexOf('@') !== -1) {
                    title = t.textContent.trim();
                }

                const hover = document.createElement('div');
                hover.className = 'hover-div';
                hover.innerHTML =
                    '<div class="text_bottom">' +
                    '<span class="titre">' + title + '</span>' +
                    '<div class="description">&nbsp;</div>' +
                    '<span class="plus_dinfos">' + moreInfoLabel() + '</span>'+
                    '</div>';

                card.appendChild(hover);
            });
        });

        observer.observe(root, { childList: true, subtree: true });
    }

    function initFlowboxWithTags(wrapper) {
        // wrapper = .flowbox-with-tags
        const sectionId = wrapper.id.replace('flowbox-with-tags-', '');
        const flowKey = wrapper.getAttribute('data-key');
        const flowLocale = wrapper.getAttribute('data-locale') || 'fr-FR';
        const containerSel = '#js-flowbox-flow-' + sectionId;
        const container = document.querySelector(containerSel);
        if (!flowKey || !container) return;

        const buttons = wrapper.querySelectorAll('button[data-tag]');
        const allTags = [];
        buttons.forEach(function (btn) {
            const v = (btn.getAttribute('data-tag') || '').trim();
            if (v) allTags.push(v);
        });

        window.flowbox('init', {
            container: containerSel,
            key: flowKey,
            locale: flowLocale,
            tags: allTags,
            tagsOperator: 'any'
        });

        const tagsBar = wrapper.querySelector('.tags');
        if (!tagsBar) return;

        function updateFlow(activeTags) {
            if (!activeTags || (Array.isArray(activeTags) && activeTags.length === 0)) {
                window.flowbox('update', {
                    key: flowKey,
                    tags: allTags,
                    tagsOperator: 'any'
                });
                return;
            }

            window.flowbox('update', {
                key: flowKey,
                tags: activeTags,
                tagsOperator: 'and'
            });
        }

        function getActiveTags() {
            const actives = [];
            wrapper.querySelectorAll('.tags button[data-tag].active').forEach(function (b) {
                const t = (b.getAttribute('data-tag') || '').trim();
                if (t) actives.push(t);
            });
            return actives;
        }

        tagsBar.addEventListener('click', function (e) {
            const btn = e.target.closest('button');
            if (!btn) return;

            if (btn.matches('button.reset, button[data-tag=""]')) {
                wrapper.querySelectorAll('.tags button.active').forEach(function (b) { b.classList.remove('active'); });
                updateFlow([]); // reset
                return;
            }

            if (btn.hasAttribute('data-tag')) {
                btn.classList.toggle('active');
                const activeTags = getActiveTags();
                updateFlow(activeTags);
            }
        });

        addHoverDivListing(container);

        const resizeHandler = debounce(function () {

        }, 200);
        window.addEventListener('resize', resizeHandler);
    }

    function boot() {
        document.querySelectorAll('.flowbox-with-tags[id^="flowbox-with-tags-"]').forEach(function (wrapper) {
            initFlowboxWithTags(wrapper);
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', boot);
    } else {
        boot();
    }
})();

(function () {
    var ROOT_SEL = '[id^="js-flowbox-flow-"]';

    function debounce(fn, wait) {
        var t;
        return function () {
            var ctx = this, args = arguments;
            clearTimeout(t);
            t = setTimeout(function () { fn.apply(ctx, args); }, wait || 150);
        };
    }

    function getLocale(root) {
        return (root.getAttribute('data-flowbox-locale') || root.getAttribute('lang') || '').toLowerCase();
    }

    function i18n(root) {
        var l = getLocale(root);
        var isNl = (l.indexOf('nl') === 0 || l.indexOf('nl-') === 0);
        return {
            title: '#bobochicparis',
            desc: isNl
                ? 'Deel je mooiste foto’s met deze hashtag om op onze site te verschijnen!'
                : 'Partagez vos plus belles photos avec ce Hashtag pour apparaître sur notre site !'
        };
    }

    function getCoverImg(root) {
        var url = root.getAttribute('data-flowbox-cover-img');
        if (url) return url;
        var img = root.querySelector('img');
        return (img && img.getAttribute('src')) ? img.getAttribute('src') : '';
    }

    function removeMagicFill(root) {
        root.classList.remove('bz-align-left');
        var list = root.querySelector('.slick-list');
        if (!list) return;
        var existing = list.querySelector('.bobo-magic-fill');
        if (existing) existing.remove();
    }

    function hasVisibleArrows(root) {
        // slick arrows OR flowbox controls
        var candidates = root.querySelectorAll('.slick-arrow, .bzfy-c-carousel-control');
        for (var i = 0; i < candidates.length; i++) {
            var st = window.getComputedStyle(candidates[i]);
            if (st.display !== 'none' && st.visibility !== 'hidden' && st.opacity !== '0') return true;
        }
        return false;
    }

    function computeState(root) {
        var list = root.querySelector('.slick-list');
        var track = root.querySelector('.slick-track');
        if (!list || !track) return null;

        var slides = track.querySelectorAll('.slick-slide:not(.slick-cloned)');
        if (!slides || slides.length === 0) return null;

        var listW = list.clientWidth;
        var totalW = 0;

        for (var i = 0; i < slides.length; i++) {
            var rect = slides[i].getBoundingClientRect();
            var st = window.getComputedStyle(slides[i]);
            var ml = parseFloat(st.marginLeft) || 0;
            var mr = parseFloat(st.marginRight) || 0;
            totalW += rect.width + ml + mr;
        }

        var space = Math.max(0, Math.round(listW - totalW));
        var arrows = hasVisibleArrows(root);

        return {
            list: list,
            track: track,
            slidesCount: slides.length,
            space: space,
            arrows: arrows
        };
    }

    function applyMagicFill(root, state) {
        // Reset (but only inside slick-list to avoid observer on root doing too much)
        removeMagicFill(root);

        // Match your Presta condition
        if (state.space > 300 && !state.arrows) {
            root.classList.add('bz-align-left');

            var cover = getCoverImg(root);
            var txt = i18n(root);

            var magic = document.createElement('div');
            magic.className = 'bobo-magic-fill';
            magic.style.width = state.space + 'px';

            magic.innerHTML =
                '<div class="bobo-magic-mask">' +
                '<div class="overflow-hidden">' +
                '<div class="bobo-blur" style="background:url(' + (cover || '') + ') no-repeat center center / cover;"></div>' +
                '</div>' +
                '<div class="bz-magic-title">' + txt.title + '</div>' +
                '<div class="bz-magic-text">' + txt.desc + '</div>' +
                '</div>';

            state.list.style.position = 'relative';
            state.list.appendChild(magic);
        }
    }

    function bootForRoot(root) {
        if (!root || root.dataset.magicFillBooted === '1') return;
        root.dataset.magicFillBooted = '1';

        var mo = null;
        var isUpdating = false;

        // Memo to avoid redoing same work
        var lastKey = '';

        function update() {
            if (isUpdating) return;

            var state = computeState(root);

            // If carousel not ready, ensure no filler and exit
            if (!state) {
                // Avoid useless DOM operations if already clean
                if (root.classList.contains('bz-align-left')) removeMagicFill(root);
                return;
            }

            // Create a stable key for state
            var key = state.slidesCount + '|' + state.space + '|' + (state.arrows ? '1' : '0');

            // If nothing changed, don't touch DOM (prevents loops + improves perf)
            if (key === lastKey) return;
            lastKey = key;

            // Temporarily disconnect observer while we mutate DOM
            isUpdating = true;
            if (mo) mo.disconnect();

            try {
                applyMagicFill(root, state);
            } finally {
                // Reconnect observer AFTER DOM changes
                if (mo) mo.observe(root, { childList: true, subtree: true });
                isUpdating = false;
            }
        }

        // Observe changes but debounce the update to avoid thrash
        mo = new MutationObserver(debounce(update, 150));
        mo.observe(root, { childList: true, subtree: true });

        // Initial and on resize
        update();
        window.addEventListener('resize', debounce(update, 200));

        // Shopify theme editor cleanup
        document.addEventListener('shopify:section:unload', function (e) {
            if (e && e.target && e.target.contains(root)) {
                if (mo) mo.disconnect();
            }
        });
    }

    function boot() {
        document.querySelectorAll(ROOT_SEL).forEach(bootForRoot);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', boot);
    } else {
        boot();
    }
})();
